import apiClient from '@/api/client'

export default {
  fetchAll(criteria) {
    return apiClient.get('headline/user/experiments', criteria)
  },
}
